<template>
   <el-card class="box-card" shadow="never" :style="{height:'600px',width:'100%'}">
      <h4>{{ title }}</h4>
      <div id="chart" :style="{height:'500px',width:'100%'}" ></div>
    </el-card>
  </template>
  <script>
  
  import * as echarts from 'echarts';
  import salesAPI from '@/services/API/sales.js'
  import dayjs from 'dayjs'
  import portausUtils from '@/utils/portaus-utils';

  export default {
      name: 'Sales-graphic',
      props: {
            customerId : {
              type : Number,
            },
            filters: {
              type: Object,
            },
            title : {
              type: String,
            },
            showQuantity: {
              type: Boolean,
              default: false,
            }
          },
        data() {
            return {
              sales: [],
              loading : false
              }
      },
    computed: {
      valuesLabel() {
        return this.$i18n.t('reports.values');
      },
      agencyFeesLabel() {
        return this.$i18n.t('products.agencyFees');
      },
      rebateLabel() {
        return this.$i18n.t('sales_orders.rebate');
      },
      qtyBtLabel() {
        return this.$i18n.t('common.QtyBt');
      },
      qty9LLabel() {
        return this.$i18n.t('common.Qty9L');
      },
    },
    components : {
    },
    methods : {
      formatAmount(amount) {
            return portausUtils.formatAmount(amount, this.$i18n.locale);
        },
        formatNumber(amount) {
            return portausUtils.formatNumber(amount, this.$i18n.locale);
        },
      initChart() {
        const xAxis = [];
        const months = {};
        const actualMonth = dayjs().month()+1;
        const startDate = dayjs().subtract(1, 'year')
        let currentMonth = startDate.month() + 2;
        if (currentMonth > 12) {
          currentMonth = currentMonth - 12;
        }
        for (var i = 0; i < 12; i++) {
          // Cela déterminera quand quel slot du tableau mettre les valeurs
          months[currentMonth] = i;
          xAxis.push(dayjs().month(currentMonth-1).format('MMM'));
          
          if (currentMonth >= 12) {
            currentMonth = 0;
          }
          currentMonth++;
        }
        const agencyFees = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        const values = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        const discount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        const quantity = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        const quantity9L = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        _.forEach(this.sales, s => {
          const index = months[s.txn_month];
          agencyFees[index] = Math.round(s.agencyfees * 100) / 100;
          values[index] = Math.round(s.value * 100) / 100;
          discount[index] = Math.round(s.discount * 100) / 100;
          quantity[index] = Math.round(s.qty * 100) / 100;
          quantity9L[index] = Math.round(s.qty9l * 100) / 100;
        })

        this.chart = echarts.init(document.getElementById('chart'))
        var series = [
          {
              data: values,
              type: 'bar',
              stack: 'a',
              name: this.valuesLabel,
              tooltip: { valueFormatter: (value) => this.formatAmount(value)}
            },
            {
              data: agencyFees,
              type: 'bar',
              stack: 'b',
              name: this.agencyFeesLabel,
              tooltip: { valueFormatter: (value) => this.formatAmount(value)}
            },
            {
              data: discount,
              type: 'bar',
              stack: 'c',
              name: this.rebateLabel,
              tooltip: { valueFormatter: (value) => this.formatAmount(value)}
            }
            ,
          ];
        if (this.showQuantity === true) {
          series.push({
              data: quantity,
              type: 'bar',
              stack: 'd',
              name: this.qtyBtLabel,
              tooltip: { valueFormatter: (value) => this.formatNumber(value)}
            },
            {
              data: quantity9L,
              type: 'bar',
              stack: 'e',
              name: this.qty9LLabel,
              tooltip: { valueFormatter: (value) => this.formatNumber(value)}
            });
        }
        const stackInfo = {};
        for (let i = 0; i < series[0].data.length; ++i) {
          for (let j = 0; j < series.length; ++j) {
            const stackName = series[j].stack;
            if (!stackName) {
              continue;
            }
            if (!stackInfo[stackName]) {
              stackInfo[stackName] = {
                stackStart: [],
                stackEnd: []
              };
            }
            const info = stackInfo[stackName];
            const data = series[j].data[i];
            if (data && data !== '-') {
              if (info.stackStart[i] == null) {
                info.stackStart[i] = j;
              }
              info.stackEnd[i] = j;
            }
          }
        }
        for (let i = 0; i < series.length; ++i) {
          const data = series[i].data;
          const info = stackInfo[series[i].stack];
          for (let j = 0; j < series[i].data.length; ++j) {
            // const isStart = info.stackStart[j] === i;
            const isEnd = info.stackEnd[j] === i;
            const topBorder = isEnd ? 20 : 0;
            const bottomBorder = 0;
            data[j] = {
              value: data[j],
              itemStyle: {
                borderRadius: [topBorder, topBorder, bottomBorder, bottomBorder]
              }
            };
          }
        }
        const option = {
          xAxis: {
            type: 'category',
            data: xAxis,
          },
          yAxis: {
            type: 'value'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {},
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          series: series
        };
        this.chart.setOption(option);
      },
      fetchSales() {
        this.loading = true;
        var utc = require('dayjs/plugin/utc')
        dayjs.extend(utc)
        const startDate = dayjs().subtract('1', 'Year').endOf('month').add(1, 'day').utc().format()
        const endDate = dayjs().endOf('month').utc().format();

        const productId = _.get(this.filters, 'productId');

        const params = {
          customerId: this.customerId != null ? this.customerId : undefined,
          productId: _.get(this.filters, 'productId') != null ? _.get(this.filters, 'productId') : undefined,
          inventoryId: _.get(this.filters, 'inventoryId') != null ? _.get(this.filters, 'inventoryId') : undefined,
          repId: _.get(this.filters, 'repId') != null ? _.get(this.filters, 'repId') : undefined,
          providerId: _.get(this.filters, 'providerId') != null ? _.get(this.filters, 'providerId') : undefined,
          productTypeId: _.get(this.filters, 'productTypeId') != null ? _.get(this.filters, 'productTypeId') : undefined,
          groupBy: 'MONTH',
          startDate,
          endDate,
        }
        // Il faut au moins avoir un des deux paramètre suivant...
        if (params.inventoryId != null || params.customerId != null) {
          return salesAPI.getSalesEvolution(params)
            .then((sales) => {
              this.sales = sales;
              this.loading = false;
            })
        }
        
      }
    },
    watch: {
      filters: function (val) {
           this.fetchSales()
           .then(() => this.initChart());
        }
    },
    mounted(){
      return this.fetchSales()
      .then(() => this.initChart());
    }
  }
  </script>
  <style lang="scss" scoped>
  @import '../assets/scss/_variables';
  
  </style>
  